import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

export type LegislationAgenciesType = "marginalia" | "superiores";

export interface LegislationAgencies {
  value: string;
  label: string;
}

export const getLegislationAgencies = async () => {
  const response =
    await apiInstance.get<LegislationAgencies[]>("legislacao/orgaos");
  return response.data;
};

export const useLegislationAgenciesQuery = () =>
  useQuery({
    queryKey: ["get-legislation-agencies"],
    queryFn: () => getLegislationAgencies(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: (count) => {
      return count < 2;
    },
  });
